export default __webpack_public_path__ + "static/media/fb1.929ee1d0.svg";